import { customersAPI, booksAPI } from '../services/api';

/**
 * חפש לקוחות לפי שם, טלפון, או אימייל
 */
export const searchCustomers = async (searchTerm) => {
  if (searchTerm.trim().length < 1) {
    return [];
  }

  try {
    const response = await customersAPI.getAll();
    // התמודד עם שני מבנים אפשריים: array ישיר או { data: [...] }
    const customers = Array.isArray(response.data) ? response.data : (Array.isArray(response.data?.data) ? response.data.data : []);
    return customers.filter(customer =>
      customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (customer.phone && customer.phone.includes(searchTerm)) ||
      (customer.email && customer.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (customer.identity_id && customer.identity_id.toString().includes(searchTerm))
    );
  } catch (error) {
    console.error('Error searching customers:', error);
    return [];
  }
};

/**
 * חפש ספרים לפי שם, מחבר, או ברקוד
 */
export const searchBooks = async (searchTerm, onlyAvailable = false) => {
  if (searchTerm.trim().length < 1) {
    return [];
  }

  try {
    const response = await booksAPI.getAll();
    // ה-API מחזיר { data: [...], pagination: {...} }
    const books = Array.isArray(response.data) ? response.data : (response.data?.data || []);
    console.log('All books from API:', books);
    console.log('Search term:', searchTerm);
    
    // Filter out null or invalid books
    const validBooks = books.filter(book => book && book.id);
    
    const filtered = validBooks.filter(book =>
      (!onlyAvailable || (book.status_text && book.status_text.includes('זמין') && !book.status_text.includes('לא'))) && (
        (book.book_name && book.book_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (book.author && book.author.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (book.barcode && book.barcode.includes(searchTerm))
      )
    );
    console.log('Filtered results:', filtered);
    return filtered;
  } catch (error) {
    console.error('Error searching books:', error);
    return [];
  }
};
